<template>
    <div :class="['lg-product-wrapper product-list-card p-4 mt-8 rounded-md bg-[var(--background-color-1)] border border-[var(--color-border)] w-full', {'colum-2 two-colum-parent-product col-lg-6': showTwoColumn}]">
        <div class="inner flex items-center justify-between">
            <div class="lg-left-content flex items-center">
                <router-link :to="`/product/${productDate.id}`" class="thumbnail overflow-hidden rounded-md">
                    <img :src="productDate.productImage" :alt="productDate.productName" @load="$emit('handleImageLoad')" class="rounded-md transition-transform hover:scale-105">
                </router-link>
                <div class="read-content ml-8">
                    <div class="product-share-wrapper flex justify-between items-center mb-4">
                        <div class="profile-share flex items-center">
                            <router-link v-for="(author, index) in productDate.authors"
                                         :key="`author-${index}`"
                                         :to="`/author/${author.id}`"
                                         class="avatar relative z-10 transition-transform hover:z-20 hover:translate-y-[-3px] hover:scale-110"
                                         :data-tooltip="author.name">
                                <img :src="author.image" :alt="author.name" class="max-w-[30px] rounded-full border-2 border-gray-600">
                            </router-link>
                            <router-link to="#" class="more-author-text text-gray-400 inline-block pl-2 hover:text-primary hover:transform-none">
                                {{ productDate.biddingAmount }}+ Place Bit.
                            </router-link>
                        </div>
                        <div class="last-bid font-semibold text-primary">{{ productDate.lastBid }}</div>
                    </div>
                    <router-link :to="`/product/${productDate.id}`">
                        <h6 class="title block font-medium text-lg transition-colors mb-4 hover:text-primary">{{ productDate.productName }}</h6>
                    </router-link>
                    <span class="latest-bid block mt-3">{{ productDate.latestBid }}</span>
                    <div class="share-wrapper d-flex flex items-center">
                        <div class="react-area relative z-10 flex items-center transition-all cursor-pointer p-1 px-3 rounded-md mr-4">
                            <i class="feather-heart mr-1 w-4 text-white"/>
                            <span class="number text-sm text-white">{{ productDate.reacted }}</span>
                        </div>
                        <div class="share-btn share-btn-activation dropdown relative z-10">
                            <button class="icon border-0 p-0 m-0" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="feather-more-horizontal"/>
                            </button>
                            <div class="share-btn-setting dropdown-menu dropdown-menu-end">
                                <button type="button"
                                        class="btn-setting-text share-text"
                                        data-bs-toggle="modal"
                                        data-bs-target="#shareModal">
                                    Share
                                </button>
                                <button type="button"
                                        class="btn-setting-text report-text"
                                        data-bs-toggle="modal"
                                        data-bs-target="#reportModal">
                                    Report
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button"
                    class="btn btn-primary-alta mr-8 rounded-md py-3 px-6"
                    data-bs-toggle="modal"
                    data-bs-target="#placebidModal">
                Place a Bid
            </button>
        </div>
    </div>
</template>

<script>
    import Countdown from '@/components/product/Countdown'

    export default {
        name: 'ProductListCard',
        components: {Countdown},
        props: {
            productDate: {},
            productStyleClass: {
                type: String
            },
            showPlaceBid: {
                type: Boolean,
                default: false
            },
            showTwoColumn: {
                type: Boolean,
                default: false
            }
        }
    }
</script>